export default "__VITE_ASSET__TkFfR3$y__"